import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Setting } from '@common/interfaces/setting.interface';
import { SettingKeyCodes } from '@common/known-types/setting-key.codes';
import { CommonService } from '@common/services/common.service';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {
    token: string;
    username: string;
    newPassword = '';
    repeatNewPassword = '';
    isResetting = false;
    logo = environment.settings.header.logo;
    version = environment.version;

    constructor(
        protected commonService: CommonService,
        private activatedRoute: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.token = this.activatedRoute.snapshot.queryParams['token'];
        this.username = this.activatedRoute.snapshot.queryParams['username'];

        if (!this.token || !this.username) {
            this.commonService.router.navigate(['/login']);
            return;
        }

        this.getAppSettings();
    }

    passwordsMatch(): boolean {
        return this.newPassword === this.repeatNewPassword;
    }

    canSubmit(): boolean {
        return !this.isResetting && this.newPassword && this.repeatNewPassword && this.passwordsMatch();
    }

    async resetPassword() {
        if (!this.canSubmit()) {
            return;
        }

        this.isResetting = true;

        try {
            await this.commonService.userService.resetPassword(this.token, this.newPassword, this.repeatNewPassword);

            this.commonService.toastrNotificationService.show({
                type: 'success',
                message: 'Password reset successful! You can now log in with your new password.',
                title: 'Success'
            });

            this.commonService.router.navigate(['/login']);
        } catch (error) {
            this.commonService.toastrNotificationService.show({
                type: 'error',
                message: error || 'Failed to reset password. Please try again.',
                title: 'Error'
            });
        } finally {
            this.isResetting = false;
        }
    }

    private getAppSettings() {
        this.commonService.queryService.queryClient
            .ensureQueryData({ queryKey: ['loginSettings'] })
            .then((result: Setting[]) => {
                const companyLogo = result?.find((s: Setting) => s.key === SettingKeyCodes.Logo);
                if (companyLogo) this.handleLogo(companyLogo.value);
            })
            .catch(() => {});
    }

    private handleLogo(imageContent: string) {
        const decodedData = atob(imageContent);
        const uint8Array = new Uint8Array(decodedData.length);
        for (let i = 0; i < decodedData.length; ++i) {
            uint8Array[i] = decodedData.charCodeAt(i);
        }
        const blob = new Blob([uint8Array]);
        this.logo = URL.createObjectURL(blob);
    }
}
